import { createSelector } from 'reselect';
import { buildQuantityArrayFromQuantityConfig } from '../reducers/bundle-picker';

const getBundleSales = state => state.bundleSales.bundles;

export const getGroupedBundleSalesByEvent = createSelector(
    [getBundleSales],
    (bundleSales) => {
        const rowsByEvent = {};

        bundleSales.forEach(bundleSale => {

            if (bundleSale && typeof bundleSale === 'object') {
                bundleSale = {
                    ...bundleSale,
                    quantityOptions: buildQuantityArrayFromQuantityConfig(
                        bundleSale?.bundle_min_qty ?? 0,
                        bundleSale?.bundle_max_qty ?? 10,
                        bundleSale?.bundle_inc ?? 1
                    ),
                }
            }


            if (rowsByEvent[bundleSale.event_id] === undefined) {
                rowsByEvent[bundleSale.event_id] = [];
            }

            let rowFound = false;
            for(let row of rowsByEvent[bundleSale.event_id]) {
                let firstBundleSale = row[0];
                let rowBundleProducts = (Object.values(firstBundleSale.contents.products).length) ? Object.values(firstBundleSale.contents.products) : Object.values(firstBundleSale.contents.tickets);
                let bundleSaleProducts = (Object.values(bundleSale.contents.products).length) ? Object.values(bundleSale.contents.products) : Object.values(bundleSale.contents.tickets);

                if (bundleSale.bundle_id === firstBundleSale.bundle_id && rowBundleProducts.length === bundleSaleProducts.length && compareKeys(rowBundleProducts, bundleSaleProducts)) {
                    row.push(bundleSale);
                    rowFound = true;
                    break; 
                }
            }

            if (!rowFound) {
                rowsByEvent[bundleSale.event_id].push([ bundleSale ]);
            }
        });

        return rowsByEvent;
    }
);

export function compareKeys(a, b) {
    let equal = false;
    a.forEach(prod => {
        b.forEach(config => {
            equal = JSON.stringify(Object.keys(prod).sort()) === JSON.stringify(Object.keys(config).sort());
            if (equal === false) {
                return false;
            }
        })
    });

    return equal;
}

export const getBundleSaleQuantities = createSelector(
    [getBundleSales],
    (bundleSales) => {
        let bundles = {};
        bundleSales.forEach(bundleSale => {
            if (!bundles[bundleSale.bundle_id]) {
                bundles[bundleSale.bundle_id] = {};
            }

            Object.keys(bundleSale.contents.products).forEach(productId => {
                if (!bundles[bundleSale.bundle_id][productId]) {
                    bundles[bundleSale.bundle_id][productId] = {};
                }
                Object.keys(bundleSale.contents.products[productId]).forEach(configurationId => {
                    if (bundles[bundleSale.bundle_id][productId][configurationId]) {
                        bundles[bundleSale.bundle_id][productId][configurationId] += 1;
                    } else {
                        bundles[bundleSale.bundle_id][productId][configurationId] = 1
                    }
                })
            })
        });

        return bundles;
    }
);
